import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#CE2828" }) => {
  return (
    <svg
      width="12"
      height="4"
      viewBox="0 0 12 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.715457 4.67912e-05C0.325745 -0.00423657 0.00582473 0.289523 7.89088e-05 0.656932C-0.00580053 1.03199 0.317636 1.33775 0.715457 1.33335H11.2845C11.6824 1.33776 12.0057 1.03199 11.9999 0.656932C11.9942 0.289523 11.6743 -0.00426177 11.2845 4.67912e-05C7.76152 4.67912e-05 4.23849 4.67912e-05 0.715457 4.67912e-05ZM2.12964 2.66665C1.73993 2.66237 1.42001 2.95613 1.41426 3.32354C1.40838 3.69859 1.73182 4.00435 2.12964 3.99995H9.86208C10.2599 4.00436 10.5833 3.69859 10.5775 3.32354C10.5717 2.95613 10.2518 2.66234 9.86208 2.66665C7.2846 2.66665 4.70712 2.66665 2.12964 2.66665Z"
        fill="white"
      />
    </svg>
  );
};

export default memo(Icon);
